module.exports = __webpack_public_path__ + "img/cm2.325e17b5.png";